import React, {useState,useEffect} from 'react'
import apiClient from '../api/apiClient'
import CreateStudentClassModal from '../components/CreateStudentClassModal'
//import './StudenClassStudentAdminPage.css'
import {useAuth} from '../context/AuthContext'

export default function StudentClassAdminPage(){
    const {user} = useAuth();
    const schoolID = user.scId
    console.log(`schholie er ${schoolID}`)

    const [studentClassList, setStudentClassList] = useState([])
    const [searchTerm, setSearchTerm] = useState(null)
    const [createStudentClassModal, setCreateStudentClassModal] = useState(false)


    async function fetchStudentClasses(){
        try{
            const res = await apiClient.get('/api/studentclass/getall', {
                params: {schoolID: schoolID}
            })
            setStudentClassList(res.data)
        }catch(e){
            console.log("error in fetchSTudentclass")
            console.log(e)
        }   
    }

    useEffect(()=>{
        fetchStudentClasses()
    },[])

    async function createStudentClass(studentClassData){
        console.log("creating shold")
        try{
            await apiClient.post('/api/studentclass/createstudentclass', studentClassData)
            setCreateStudentClassModal(false)
            fetchStudentClasses();
        }catch(e){
            console.log("error in create student class")
            console.log(studentClassData)
        }
    }

    function handleEdit(){
        console.log("vi editerer en klasse")
    }

    return(
        <div>
            <div className = "table-card">
                <div className="filter-bar">
                    <input
                        type="text"
                        className="search-input"
                        placeHolder="Søg..."
                        value={searchTerm}
                        onChange={(e)=>setSearchTerm(e.target.value)}
                    />
                    <button style={{
                        backgroundColor: '#003366', color: 'white', padding: '10px 20px',
                        border: 'none', borderRadius: '8px', cursor: 'pointer'}}
                        onClick={()=>setCreateStudentClassModal(true)}>
                            Opret hold
                    </button>                    
                </div>
                <table className="censor-table">
                    <thead>
                        <tr>
                            <th style={{width: '5%'}}>Hold-id</th>
                            <th style={{width: '20%'}}>Holdnavn</th>
                            <th style={{width: '15%'}}>Underviser</th>
                            <th style={{width: '12%'}}>Internt navn</th>
                            <th style={{width: '13%'}}>Studieretning</th>
                            <th style={{width: '7%'}}>Modul</th>
                            <th style={{width: '20%'}}>Periode</th>
                        </tr>
                    </thead>
                    <tbody>
                        {studentClassList.map((studentClass)=>{
                            return(
                                <tr key={studentClass.id}>
                                    <td>{studentClass.id}</td>
                                    <td>{studentClass.holdnavn}</td>
                                    <td>{studentClass.underviser_id}</td>
                                    <td>{studentClass.interntholdnummer}</td>
                                    <td>{studentClass.studieretning}</td>
                                    <td>{studentClass.modul}</td>
                                    <td>{`${new Date(studentClass.startdato).
                                        toLocaleDateString('da-DK', {day: 'numeric', month: 'numeric', year: 'numeric'})}
                                        -${new Date(studentClass.slutdato).
                                        toLocaleDateString('da-DK', {day: 'numeric', month: 'numeric', year: 'numeric'})}`}</td>
                                    <td>
                                        <button onClick={()=>handleEdit()} 
                                            style={{
                                                background: 'none', border: '1px solid #ddd',
                                                padding: '5px 10px', borderRadius: '4px', cursor: 'pointer'
                                            }}>
                                            Rediger
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </div>
            {createStudentClassModal &&
                <CreateStudentClassModal
                    schoolID = {schoolID}
                    onCreate={createStudentClass}
                    onClose={() => setCreateStudentClassModal(false)}   
                />
            }
        </div>

    )
}